// extracted by mini-css-extract-plugin
module.exports = {"delta-pro-ultra-B":"B_delta-pro-ultra-B___lOw8"};